<template>
    <span>
        <a-button size="small" type="primary" icon="check" v-on:click.prevent="showModal">{{$t('Sol. Vacaciones')}}</a-button>
        <a-modal :title="$t('Solicitar Vacaciones')"
                 :visible="modalVisible"
                 @ok="confirmar"
                 :confirmLoading="modalLoading"
                 @cancel="cancelar">
              <a-form :form="form" @submit="confirmar">
                <g-dropdown v-if="listaValoresToCampoNumerico" endpoint="hierarchy_lookup"
                            :label="$t('Días Solicitados')"
                            :decorator="['dias_solicitados', { rules: [{ required: isDiasSolicitados, message: 'Valor requerido' }] }]"
                            :formItemConfig="fiOptions"
                            :params="diasParams">
                </g-dropdown>
                <a-form-item  v-else v-bind="fiOptions" :label="$t('Días Solicitados')">
                    <a-input-number
                      style="width: 100%"
                      v-decorator="['dias_solicitados', { rules: [{ required: false}] }]"/>
                </a-form-item>
                  <a-form-item :label="$t('Fecha Inicio Vacaciones')" v-bind="fiOptions">
                      <a-date-picker style="width: 100%"
                                     valueFormat="Y-MM-DD"
                                     v-decorator="['fecha_inicio', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                     :disabled="modalLoading"></a-date-picker>
                  </a-form-item>

                  <a-form-item :label="$t('Fecha Fin Vacaciones')" v-bind="fiOptions">
                      <a-input v-model="fecha_regreso"
                               disabled>
                          <a-tooltip slot="suffix" title="Calculado automáticamente">
                              <a-icon v-if="modalLoading" type="loading"/>
                              <a-icon v-else type="info-circle" style="color: rgba(0,0,0,.45)"/>
                         </a-tooltip>
                      </a-input>
                  </a-form-item>

                  <a-form-item v-if="mostrarDiasSolicitadosDinero" :label="$t('Días Solicitados en Dinero')" v-bind="fiOptions">
                      <a-input-number style="width: 100%"
                                      v-decorator="['dias_solicitados_en_dinero',
                                      { rules: [
                                            { required: false},
                                            { type: 'integer', min: 1, message: 'El valor debe estar entre 1 y 99' },
                                            { type: 'integer', max: 999, message: 'El valor debe estar entre 1 y 999' },
                                        ]
                                      }
                                      ]" :disabled="modalLoading">
                      </a-input-number>
                  </a-form-item>

                  <a-form-item v-bind="fchkOptions" v-if="$getConfigValue('MOSTRAR_ANTICIPADO_EN_DASHBOARD', false) === 'SI'">
                        <a-checkbox v-decorator="['anticipado']" :disabled="modalLoading">Anticipado</a-checkbox>
                  </a-form-item>

                  <a-row>
                      <a-upload-dragger name="file"
                                        :beforeUpload="beforeUpload"
                                        :fileList="fileList"
                                        @change="fileChange"
                                        v-if="canUploadVacationFiles"
                      >
                        <p class="ant-upload-drag-icon">
                            <a-icon type="inbox"/>
                        </p>
                        <p class="ant-upload-text">Clic o arrastrar y soltar en esta área para subir un archivo</p>
                        <p class="ant-upload-hint">
                            Solo es permitido seleccionar un archivo
                        </p>
                    </a-upload-dragger>
                  </a-row>

                  <a-alert type="error" :message="mensajeError" v-if="error"/>
              </a-form>
        </a-modal>
    </span>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        isDiasSolicitados: this.$getConfigValue('SOL_VAC_DIAS_SOLICITADOS_REQUERIDO', 'SI') === 'SI',
        modalVisible: false,
        modalLoading: true,
        fecha_regreso: '',
        mensajeError: '',
        error: false,
        form: this.$form.createForm(this, {
          name: 'solicitar',
          onFieldsChange: (_, changedFields) => {
            this.actualizaFechaRegreso(changedFields)
          }
        }),
        fiOptions: {
          'label-col': {span: 10},
          'wrapper-col': {span: 14},
          'has-feedback': true
        },
        fchkOptions: {
          'label-col': {span: 10},
          'wrapper-col': {offset: 10, span: 14},
          'has-feedback': true
        },
        diasParams: {
          h_lookup_type: 'DIAS_SOL_VAC',
          use_code: true,
          ordenar_x_id_h_lookup: true
        },
        fileList: [],
        canUploadVacationFiles: this.$getConfigValue('SUBIR_ARCHIVOS_VACACIONES_DASHBOARD', 'NO') === 'SI'
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.modalLoading = false
      },
      confirmar (e) {
        e && e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            this.modalLoading = true
            let reqData = new FormData()
            let request = {
              fecha_inicio: DateUtils.forBackEnd(values.fecha_inicio),
              dias: typeof values.dias_solicitados === 'undefined' ? 0 : values.dias_solicitados,
              diasDinero: values.dias_solicitados_en_dinero,
              opciones: values.anticipado
            }
            for (let prop in request) {
              if (!this.$isEmpty(request[prop])) {
                reqData.append(prop, request[prop])
              }
            }
            if (this.fileList.length > 0) {
              reqData.append('adjunto', this.fileList[0])
            }
            this.httpClient.getInstance().post('ss/solicitar_vacaciones', reqData)
              .then((response) => {
                if (parseInt(response.data.resultado) === 0) {
                  this.error = true
                  this.mensajeError = response.data.mensaje
                } else {
                  this.error = false
                  this.mensajeError = ''
                  this.modalVisible = false
                  Mensajes.success('Correcto', response.data.mensaje)
                  this.form.resetFields()
                  this.$emit('success', {})
                }
              })
              .catch((error) => {
                Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible realizar la solicitud.'))
                this.error = true
              })
              .then(() => {
                this.modalLoading = false
              })
          }
        })
      },
      showModal () {
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
      },
      actualizaFechaRegreso (camposCambiados) {
        if (this.modalLoading || camposCambiados.dias_solicitados) return

        if (JsUtils.isEmpty(this.form.getFieldValue('fecha_inicio')) || JsUtils.isEmpty(this.form.getFieldValue('dias_solicitados')) || (this.form.getFieldValue('dias_solicitados') === 'undefined')) {
          this.fecha_regreso = ''
          return
        }
        this.modalLoading = true
        this.httpClient.getInstance().get('ss/solicitar_vacaciones/calcular_fecha_regreso', {
          params: {
            fecha_inicio: DateUtils.forBackEnd(this.form.getFieldValue('fecha_inicio')),
            dias: this.form.getFieldValue('dias_solicitados')
          }
        })
          .then((response) => {
            // si es null se asigna asi tal cual al campo fecha_regreso si no es null debe hacer lo que ya hace de formatear al hora
            if (response.data === null) {
              this.fecha_regreso = null
            } else {
              let ff = moment(response.data)
              this.fecha_regreso = ff.format('YYYY-MM-DD')
            }
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible calcular la fecha de regreso.')
          })
          .then(() => {
            this.modalLoading = false
          })
      },
      beforeUpload (file) {
        return false
      },
      fileChange (info) {
        if (info.fileList.length > 0) {
          this.fileList = [info.file]
        } else {
          this.fileList = []
        }
      }
    },
    computed: {
      listaValoresToCampoNumerico () {
        return this.$getConfigValue('DASHBOARD_SOL_VACACIONES_DIAS_SOLICITADOS_LOV', 'SI') === 'SI'
      },
      mostrarDiasSolicitadosDinero () {
        return this.$getConfigValue('MOSTRAR_DIAS_SOLICITADOS_DINERO_EN_DASHBOARD', 'SI') === 'SI'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/BotonSolicitarVacaciones.vue